import { PASSWORD_REQUIRED } from './constants';

const validations = {
  password: {
    required: {
      value: true,
      message: PASSWORD_REQUIRED,
    },
  },
};
export default validations;
